export default {
    "Terms":"Услови",
    "Account": "Рачун",
    "DataProtection":"Заштита података",
    "Privacy":"Приватност",
    "Imprint":"Импресум",
    "Help":"Помоћ",
    "Contact":"Контакт",
    "Deactivation":"Деактивација",
    "Action":"Акција",
    "Adventure":"Авантура",
    "Guess":"Погађање",
    "Maximum score":"Максимални резултат",
    "Platform":"Платформа",
    "Quiz":"Квиз",
    "Shooter":"Пуцачина",
    "Ability":"Вештина",
    "Profile":"Профил",
    "Home":"Почетна страница",
    "Page visible only to registered users.":"Страница је видљива само регистрованим корисницима.",
    "PLAY NOW!":"ИГРАЈ САДА!",
    "Games in category {Category}":"Игре у категорији {Category}",
    "To unsubscribe, enter your phone number in international format and submit the form": "За отказивање претплате унесите свој телефонски број у међународном формату и пошаљите образац",
    "If you want to cancel or have any questions about the service, send an email to: ": "Ако желите да откажете услугу или имате питања о сервису, пошаљите мејл на",
    "You have successfully unsubscribed from the service": "Успешно сте се одјавили са сервиса",
    "By registering I confirm that I am over 18 years old and I confirm that I have read and accept the terms and conditions and I hereby give up my right of withdrawal from the purchase of this product.": "Регистрацијом потврђујем да сам старији од 18 година и да сам прочитао и да прихватам услове и одредбе коришћења, те се овим одричем права на одустајање од куповине овог производа.",
    "Subscription service. Sign up now and play the best games. Price is 2x180 RSD for 7 days. Payment is made through your mobile service provider. ": "Претплатничка услуга. Пријавите се сада и играјте најбоље игре. Цена је 2x180 РСД за 7 дана. Плаћање се врши путем Вашег пружаоца услуга мобилне телефоније.",
    "We cannot identify your phone number. Please turn off your WiFi and try again. ": "Не можемо да идентификујемо Ваш телефонски број. Искључите WiFi и покушајте поново.",
    "Try again": "Покушај поново."
}


// WEBPACK FOOTER //
// ./src/i18n/rs.js